import { apiCall } from '../../utils/restclient'
import {
  ADD_PATIENT_ALLERGY,
  ADD_PATIENT_ALLERGY_ERROR,
  ADD_PATIENT_ALLERGY_SUCCESS,
  BACK_IN_QUEUE,
  BACK_IN_QUEUE_ERROR,
  COMPLETE_VISIT_CALL,
  COMPLETE_VISIT_CALL_ERROR,
  COMPLETE_VISIT_CALL_SUCCESS,
  DELETE_PATIENT_ALLERGY,
  DELETE_PATIENT_ALLERGY_ERROR,
  DELETE_PATIENT_ALLERGY_SUCCESS,
  DELETE_VISIT_NOTES,
  DELETE_VISIT_NOTES_ERROR,
  DELETE_VISIT_NOTES_SUCCESS,
  DELETE_VISIT_PATIENT_INSTRUCTIONS,
  DELETE_VISIT_PATIENT_INSTRUCTIONS_ERROR,
  DELETE_VISIT_PATIENT_INSTRUCTIONS_SUCCESS,
  END_VISIT,
  END_VISIT_ERROR,
  END_VISIT_SUCCESS,
  GET_PATIENT_PRESCRIPTIONS,
  GET_PATIENT_PRESCRIPTIONS_ERROR,
  GET_PATIENT_PRESCRIPTIONS_SUCCESS,
  GET_PATIENT_TREAT_URL,
  GET_PATIENT_TREAT_URL_ERROR,
  GET_PATIENT_TREAT_URL_SUCCESS,
  GET_PATIENTS,
  GET_PATIENTS_BACKGROUND,
  GET_PATIENTS_ERROR,
  GET_PATIENTS_SUCCESS,
  GET_PHONE_CALL_TOKEN,
  GET_PHONE_CALL_TOKEN_ERROR,
  GET_PHONE_CALL_TOKEN_SUCCESS,
  GET_PROVIDER,
  GET_PROVIDER_ERROR,
  GET_PROVIDER_SUCCESS,
  GET_VISIT_INFO,
  GET_VISIT_INFO_ERROR,
  GET_VISIT_INFO_SUCCESS,
  GET_VISIT_PATIENT_CHART,
  GET_VISIT_PATIENT_CHART_ERROR,
  GET_VISIT_PATIENT_CHART_SUCCESS,
  SAVE_VISIT_NOTES,
  SAVE_VISIT_NOTES_ERROR,
  SAVE_VISIT_NOTES_SUCCESS,
  SAVE_VISIT_PATIENT_INSTRUCTIONS,
  SAVE_VISIT_PATIENT_INSTRUCTIONS_ERROR,
  SAVE_VISIT_PATIENT_INSTRUCTIONS_SUCCESS,
  SEARCH_FOR_ICD_CODES,
  SEARCH_FOR_ICD_CODES_ERROR,
  SEARCH_FOR_ICD_CODES_SUCCESS,
  SET_VISIT_PATIENT_HAS_ALLERGIES,
  SET_VISIT_PATIENT_HAS_ALLERGIES_ERROR,
  SET_VISIT_PATIENT_HAS_ALLERGIES_SUCCESS,
  SET_VISIT_PATIENT_HAS_NO_ALLERGIES,
  SET_VISIT_PATIENT_HAS_NO_ALLERGIES_ERROR,
  SET_VISIT_PATIENT_HAS_NO_ALLERGIES_SUCCESS,
  UPDATE_ICD_CODES,
  UPDATE_ICD_CODES_ERROR,
  UPDATE_ICD_CODES_SUCCESS,
} from './WaitingRoomConstants'
import { INPERSON_PATH_SEGMENT, POST, VISITS_ENDPOINT } from '../../utils/constants'
import { ENDPOINTS } from '../../utils/endpoints'
import {
  getConfirmPatientHasNoAllergyEndPoint,
  getUnConfirmPatientHasNoAllergyEndPoint,
  methods,
} from '../../utils/apiHelper'
import {
  START_INPERSON_VISIT,
  START_INPERSON_VISIT_ERROR,
  START_INPERSON_VISIT_SUCCESS,
} from '../visits/VisitsConstants'
import { store } from '../../app/store'
import { client } from 'api/components/queryClient'
import { getGetPatientsPatientIdQueryKey, getPatientsPatientId } from 'api/generated/patient/patient'
import {
  getGetVisitsVisitIdV2QueryKey,
  getVisitsVisitIdV2,
} from 'api/generated/visit-controller-v2/visit-controller-v2'
import { getGetProfileQueryKey, getProfile } from 'api/generated/profile/profile'
import {
  getGetVisitsVisitIdPrescriptionsQueryKey,
  getVisitsVisitIdPrescriptions,
} from 'api/generated/prescription/prescription'
import { mapPrescriptionToLegacy } from '../../utils/prescriptionMapper'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const completeVisitCall = ({ visitId, IsSuccessful, isWithoutRequest, Message }) => {
  const endpoint = IsSuccessful ? `api/v1/visits/${visitId}/complete` : `api/v1/visits/${visitId}/unresolve`
  const action = {
    type: COMPLETE_VISIT_CALL,
  }
  if (isWithoutRequest) {
    return {
      type: COMPLETE_VISIT_CALL_SUCCESS,
      extraData: { visitId },
    }
  }
  const requestBody = Message?.length ? JSON.stringify({ Message }) : null
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, requestBody, {
      success: COMPLETE_VISIT_CALL_SUCCESS,
      error: COMPLETE_VISIT_CALL_ERROR,
      extraData: { visitId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPhoneCallToken = (visitId, ImageUrl, patientId, isReconnecting) => {
  const endpoint = `api/v1/visits/${visitId}/call/token`
  const action = {
    type: GET_PHONE_CALL_TOKEN,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PHONE_CALL_TOKEN_SUCCESS,
      error: GET_PHONE_CALL_TOKEN_ERROR,
      extraData: {
        profileImage: ImageUrl,
        VisitId: visitId,
        isReconnecting,
        patientId,
      },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const startInPersonVisit = (visit) => {
  const endpoint = `${VISITS_ENDPOINT}/${visit.VisitId}${INPERSON_PATH_SEGMENT}`
  const action = {
    type: START_INPERSON_VISIT,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, POST, null, null, {
      success: START_INPERSON_VISIT_SUCCESS,
      error: START_INPERSON_VISIT_ERROR,
      extraData: visit,
    })
    return action
  } catch (e) {
    console.error(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function searchForICDCodes(searchValue, searchId) {
  const endpoint = `api/v1/icdcodes?SearchValue=${encodeURIComponent(searchValue)}`
  const action = {
    type: SEARCH_FOR_ICD_CODES,
  }
  try {
    apiCall(
      endpoint,
      'GET',
      null,
      null,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      {
        success: SEARCH_FOR_ICD_CODES_SUCCESS,
        error: SEARCH_FOR_ICD_CODES_ERROR,
        extraData: { searchId },
      },
      null,
      null,
      null,
      null,
      true,
    )
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function updateICDCodes(visitId, codes) {
  const endpoint = `api/v1/visits/${visitId}/icdcodes`
  const action = {
    type: UPDATE_ICD_CODES,
  }
  const requestBody = {
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    IcdCodeIds: codes.map((code) => code.IcdCodeId),
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'POST', null, JSON.stringify(requestBody), {
      success: UPDATE_ICD_CODES_SUCCESS,
      error: UPDATE_ICD_CODES_ERROR,
      extraData: { codes, visitId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

export const getProviderProfile = () => {
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const endpoint = `api/v1/profile`
  const action = {
    type: GET_PROVIDER,
  }
  getProfile()
    .then((response) => {
      store.dispatch({
        type: GET_PROVIDER_SUCCESS,
        payload: response,
      })
      const queryKey = getGetProfileQueryKey()
      client.setQueryData(queryKey, response)
    })
    .catch((error) => {
      store.dispatch({
        type: GET_PROVIDER_ERROR,
        payload: error,
      })
    })
  return action
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export function backInQueue({ visitId, PatientInstructions }) {
  const endpoint = `api/v1/visits/${visitId}/backinwaitingroom`
  const action = {
    type: BACK_IN_QUEUE,
  }
  const requestBody = {
    PatientInstructions,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, JSON.stringify(requestBody), {
      success: COMPLETE_VISIT_CALL_SUCCESS,
      error: BACK_IN_QUEUE_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
export const getCurrentPatients = (loading = true) => {
  const endpoint = `api/v1/visits/waitingroom`
  const action = {
    type: loading ? GET_PATIENTS : GET_PATIENTS_BACKGROUND,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PATIENTS_SUCCESS,
      error: GET_PATIENTS_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const deletePatientAllergy = (patientId, allergyId) => {
  const endpoint = `api/v1/patients/${patientId}/allergies/${allergyId}`
  const action = {
    type: DELETE_PATIENT_ALLERGY,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'DELETE', null, null, {
      success: DELETE_PATIENT_ALLERGY_SUCCESS,
      error: DELETE_PATIENT_ALLERGY_ERROR,
      extraData: { patientId, allergyId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function addPatientAllergy(id, allergy) {
  const endpoint = `api/v1/patients/${id}/allergies`
  const action = {
    type: ADD_PATIENT_ALLERGY,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'POST', null, JSON.stringify(allergy), {
      success: ADD_PATIENT_ALLERGY_SUCCESS,
      error: ADD_PATIENT_ALLERGY_ERROR,
      extraData: { patientId: id, allergy },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getVisitPatientInfo = (id) => {
  const endpoint = `api/v1/patients/${id}`
  const action = {
    type: GET_VISIT_PATIENT_CHART,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_VISIT_PATIENT_CHART_SUCCESS,
      error: GET_VISIT_PATIENT_CHART_ERROR,
      extraData: { patientId: id },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getVisitInfo = (id, tabId) => (dispatch) => {
  dispatch({ type: GET_VISIT_INFO })
  return getVisitsVisitIdV2(id, { includeMostRecentMatchingVisit: true })
    .then((response) => {
      dispatch({ type: GET_VISIT_INFO_SUCCESS, payload: response, extraData: { visitId: id, tabId } })
      const queryKey = getGetVisitsVisitIdV2QueryKey(id, { includeMostRecentMatchingVisit: true })
      client.setQueryData(queryKey, response)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      getPatientsPatientId(response.PatientId)
        .then((patientResponse) => {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          const patientQueryKey = getGetPatientsPatientIdQueryKey(patientResponse.PatientId)
          client.setQueryData(patientQueryKey, patientResponse)
        })
        .catch((error) => console.error('Failed to load patient data', error))
    })
    .catch((error) => {
      dispatch({ type: GET_VISIT_INFO_ERROR, payload: error, extraData: { visitId: id, tabId } })
      throw error
    })
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const endVisit = (id) => {
  const endpoint = `api/v1/visits/${id}/end`
  const action = {
    type: END_VISIT,
  }

  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, null, {
      success: END_VISIT_SUCCESS,
      error: END_VISIT_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const saveVisitNotes = (id, Note, showError = true) => {
  const endpoint = ENDPOINTS.visitPatientNotes(id)
  const action = {
    type: SAVE_VISIT_NOTES,
  }
  const requestBody = {
    Message: Note,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'POST', null, JSON.stringify(requestBody), {
      success: SAVE_VISIT_NOTES_SUCCESS,
      error: SAVE_VISIT_NOTES_ERROR,
      extraData: { visitId: id, Notes: Note, showError },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const deleteVisitNotes = (id, Note, showError = true) => {
  const endpoint = ENDPOINTS.visitPatientNotes(id)
  const action = {
    type: DELETE_VISIT_NOTES,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'DELETE', null, null, {
      success: DELETE_VISIT_NOTES_SUCCESS,
      error: DELETE_VISIT_NOTES_ERROR,
      extraData: { visitId: id, Notes: Note, showError },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const savePatientInstructions = (id, PatientInstructions, showError = true) => {
  const endpoint = ENDPOINTS.visitPatientInstructions(id)
  const action = {
    type: SAVE_VISIT_PATIENT_INSTRUCTIONS,
  }
  const requestBody = {
    Message: PatientInstructions,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'POST', null, JSON.stringify(requestBody), {
      success: SAVE_VISIT_PATIENT_INSTRUCTIONS_SUCCESS,
      error: SAVE_VISIT_PATIENT_INSTRUCTIONS_ERROR,
      extraData: { visitId: id, PatientInstructions, showError },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const deletePatientInstructions = (id, PatientInstructions, showError = true) => {
  const endpoint = ENDPOINTS.visitPatientInstructions(id)
  const action = {
    type: DELETE_VISIT_PATIENT_INSTRUCTIONS,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'DELETE', null, null, {
      success: DELETE_VISIT_PATIENT_INSTRUCTIONS_SUCCESS,
      error: DELETE_VISIT_PATIENT_INSTRUCTIONS_ERROR,
      extraData: { visitId: id, PatientInstructions, showError },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getVisitPrescriptionCollection = (id, isSilent = false) => {
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const endpoint = `api/v1/visits/${id}/prescriptions`
  const action = {
    type: GET_PATIENT_PRESCRIPTIONS,
    payload: { isSilent },
  }

  getVisitsVisitIdPrescriptions(id)
    .then((response) => {
      store.dispatch({
        type: GET_PATIENT_PRESCRIPTIONS_SUCCESS,
        payload: (response ?? []).map(mapPrescriptionToLegacy),
        extraData: { visitId: id },
      })
      const queryKey = getGetVisitsVisitIdPrescriptionsQueryKey(id)
      client.setQueryData(queryKey, response)
    })
    .catch((error) => {
      store.dispatch({
        type: GET_PATIENT_PRESCRIPTIONS_ERROR,
        payload: error,
        extraData: { visitId: id },
      })
    })
  return action
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getVisitCallRoomTreatURL = (id) => {
  const endpoint = `api/v1/visits/${id}/treaturl`
  const action = {
    type: GET_PATIENT_TREAT_URL,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PATIENT_TREAT_URL_SUCCESS,
      error: GET_PATIENT_TREAT_URL_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPatientHasNoAllergies = (patientId, tabId) => {
  const endpoint = getConfirmPatientHasNoAllergyEndPoint(patientId)
  const action = {
    type: SET_VISIT_PATIENT_HAS_NO_ALLERGIES,
  }

  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, methods.PUT, null, null, {
      success: SET_VISIT_PATIENT_HAS_NO_ALLERGIES_SUCCESS,
      error: SET_VISIT_PATIENT_HAS_NO_ALLERGIES_ERROR,
      extraData: { patientId, tabId },
    })

    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPatientHasAllergies = (patientId, tabId) => {
  const endpoint = getUnConfirmPatientHasNoAllergyEndPoint(patientId)
  const action = {
    type: SET_VISIT_PATIENT_HAS_ALLERGIES,
  }

  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, methods.PUT, null, null, {
      success: SET_VISIT_PATIENT_HAS_ALLERGIES_SUCCESS,
      error: SET_VISIT_PATIENT_HAS_ALLERGIES_ERROR,
      extraData: { patientId, tabId },
    })

    return action
  } catch (e) {
    console.log(e)
  }
}
